import { deviceKitNameType } from "../consts";
import { deviceUtil } from "../utils";

// Device Filter Patterns
// __________________________________________________________________________
const getFilterPatternByTypeName = (deviceName) => {
  if (!deviceName) {
    return null;
  }

  // list of device type names corresponding to given device name
  const deviceTypes = deviceUtil.getDeviceTypesByName(deviceName);

  const deviceFilters = [];

  if (deviceTypes && deviceTypes?.length > 0) {
    deviceTypes.forEach((deviceType) => {
      if (deviceType !== deviceKitNameType.DEV_TYPE_KIT) {
        deviceFilters.push(`deviceTypeName='${deviceType}'`);
      }
    });

    return deviceFilters.join(" or ");
  }

  return null;
};

const getFilterPatternByDeviceName = (deviceName) => {
  if (!deviceName) {
    return null;
  }

  const deviceFilter = `deviceTypeName='${deviceName}'`;
  return deviceFilter;
};

const isChartAvailable = (selectedAppTypes, chartId) => {
  return selectedAppTypes?.some((type) =>
    type.availableDashboards?.some((d) => d.name === chartId && d.isSelected)
  );
};

const dashboardUtil = {
  // Device Filter Patterns
  // __________________________________________________________________________
  getFilterPatternByTypeName,
  getFilterPatternByDeviceName,
  isChartAvailable
};

export default dashboardUtil;
